import { call, put } from 'redux-saga/effects';
import serviceLocator, { SSAP_SVC } from '@APIs/common/service-locator';
import { setBloodRelationships } from '@actions/ssap/ssapActionCreators';

export function* bloodRelationshipsSaga() {
    const ssapService = yield call(serviceLocator, SSAP_SVC);
    const bloodRelationships = yield call([ssapService, ssapService.getBloodRelationships]);
    if(bloodRelationships) {
        yield put(setBloodRelationships(bloodRelationships));
    }
}